import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { Audit } from "@interfaces/audit.interface";
import { LogExport } from "@interfaces/logExport.interface";
import { AuditService } from "@services/audit.service";
import { ExportLogService } from "@services/exportLog.service";
import { ProtectedGridService } from "@services/protectedGrid.service";
import { ToastService } from "angular-toastify";

@Component({
	moduleId: module.id,
	selector: "audits",
	styleUrls: ["audits.css"],
	templateUrl: "audits.html"
})
export class AuditAdminComponent {
	audits: Audit[] = [];
	canExportGrid = false;
	title = "Audits";

	constructor(private router: Router, private toastService: ToastService, private auditsService: AuditService, private exportLogService: ExportLogService, private protectedGridService: ProtectedGridService) {
		this.getAudits();
		this.viewRow = this.viewRow.bind(this);
		this.checkGridExportPermissions();
	}
	
	checkGridExportPermissions() {
		this.protectedGridService.canExport("Audits")
			.subscribe(
				(res: any) => {
					this.canExportGrid = res.response;
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}

	getAudits() {
		this.auditsService.getAll()
			.subscribe(
				(res: any) => {
					this.audits = res.response.items;
					console.log(this.audits[0].id);
				},
				(err) => console.log(err),
			);
	}

	logExport() {
		const logExport = new LogExport();
		logExport.gridName = "Audits";
		this.exportLogService.logExport(logExport)
			.subscribe(
				() => console.log("Export Logged"),
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
					return false;
				},
			);
	}

	viewRow(e: any) {
		this.router.navigate([`admin/audits/${e.row.data.id}`]);
	}
}